import { z } from 'zod';
const text = z.string().nullable().optional();
const stats = z.object({
  GP: z.number().nullable().optional(),
  G: z.number().nullable().optional(),
  A: z.number().nullable().optional(),
  PTS: z.number().nullable().optional(),
  PIM: z.number().nullable().optional(),
  GAA: z.number().nullable().optional(),
  SVP: z.number().nullable().optional(),
});
export const EpProfileSchema = z.object({
  id: z.number().int().positive(),
  name: z.string().min(1),
  dateOfBirth: text,
  position: text,
  shoots: text,
  placeOfBirth: text,
  nationality: z.object({ name: text }).nullable().optional(),
  height: z.object({ metrics: z.number().nullable().optional() }).nullable().optional(),
  weight: z.object({ metrics: z.number().nullable().optional() }).nullable().optional(),
  latestStats: z
    .object({
      season: z.object({ slug: z.string() }),
      status: text,
      teamName: text,
      leagueName: text,
      team: z.object({ name: text }).nullable().optional(),
      league: z.object({ name: text }).nullable().optional(),
      regularStats: stats.nullable().optional(),
    })
    .nullable()
    .optional(),
});
export type EpProfile = z.infer<typeof EpProfileSchema>;
